import React from 'react';

import useResourceOnboardingSequence from '../../hooks/useResourceOnboardingSequence';
import { ResourceOnboardingSequenceButton } from './styled';

export interface ResourceOnboardingSequenceNextProps {
  style?: React.CSSProperties;
}

export default function ResourceOnboardingSequenceNext({
  style,
}: ResourceOnboardingSequenceNextProps) {
  const { nextStep } = useResourceOnboardingSequence();

  const handleClick = (e) => {
    e.stopPropagation();
    nextStep();
  };

  return (
    <ResourceOnboardingSequenceButton
      style={style}
      onClick={handleClick}
      className="resource-onboarding-sequence-next"
    >
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ zIndex: 1, position: 'relative' }}
      >
        <g filter="url(#filter0_b_41505_47087)">
          <rect width="22" height="22" rx="11" fill="#EB823D" fillOpacity="0.3" />
          <rect x="1" y="1" width="20" height="20" rx="10" stroke="#FFA366" strokeWidth="2" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.4861 5.70136C11.2177 5.43288 10.7823 5.43288 10.5139 5.70136C10.2454 5.96985 10.2454 6.40515 10.5139 6.67364L14.1527 10.3125H6.1875C5.8078 10.3125 5.5 10.6203 5.5 11C5.5 11.3797 5.8078 11.6875 6.1875 11.6875H14.1527L10.5139 15.3264C10.2454 15.5948 10.2454 16.0302 10.5139 16.2986C10.7823 16.5671 11.2177 16.5671 11.4861 16.2986L16.298 11.4867L16.2986 11.4861M11.4861 5.70136L16.298 10.5133ZM16.2986 10.5139C16.3001 10.5154 16.3016 10.5169 16.3031 10.5184ZM16.3031 10.5184C16.3644 10.5808 16.4138 10.6548 16.4478 10.7368C16.415 10.6576 16.3668 10.5832 16.3031 10.5184Z"
            fill="white"
          />
        </g>
        <defs>
          <filter
            id="filter0_b_41505_47087"
            x="-48"
            y="-48"
            width="118"
            height="118"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feGaussianBlur in="BackgroundImageFix" stdDeviation="24" />
            <feComposite
              in2="SourceAlpha"
              operator="in"
              result="effect1_backgroundBlur_41505_47087"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_backgroundBlur_41505_47087"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </ResourceOnboardingSequenceButton>
  );
}
